module.exports = __webpack_public_path__ + "img/brand@2x.f7322c4d.png";